import { Component } from '@angular/core';
import { RootMixin, WithMenubarMixin } from '@asp/mixins';

@Component({
  selector: 'app-staff-layout',
  templateUrl: './staff-layout.component.html',
  styleUrls: ['./staff-layout.component.scss'],
})
export class StaffLayoutComponent extends WithMenubarMixin(RootMixin) {
  constructor() {
    super();
  }
}
